import styles from '../styles/Home.module.css'

function Home() {
  return (
    <div className={styles.background}>

      <div className={styles.contPr}>
        <h1 className={styles.h1}>¡Bienvenid@ al PokeTimer!</h1>
        <h2 >Primera temporada (generaciones 1-3)</h2>
        <div className={styles.contCir}>
          <div className={styles.bCirc}>
            <div className={styles.intcirc}></div>
          </div>
          <div className={styles.circ1}></div>
          <div className={styles.circ2}></div>
          <div className={styles.circ3}></div>
        </div>
        <div className={styles.contSec}>
          <div className={styles.contTer}>
            <p className={styles.p}>Dentro de este timer podras conseguir diversos Pokémon a medida que pasa el tiempo, por lo cual para conseguir pokeballs necesitas hacer que el cronómetro corra.</p>
            <p className={styles.p}>Al llegar al nivel 10 podrás obtener una pokeball para conseguir otro pokémon salvaje aleatorio; Después de eso, cada 20 niveles podrás obtener una pokeball extra y al momento de llegar al nivel 100 con un pokémon obtendras 6 pokeball extras.</p>
            <p className={styles.p}>Los pokémon evolucionan al nivel 30. Todos los pokémon que tengan evoluciones disponibles solo podrán evolucionar 1 vez, por lo cual si tiene más de 1 evolución para poder llegar a la evolución final tienes que usar y subir de nivel tanto el pokémon base como su primera evolución.</p>
            <p className={styles.p}>Las generaciones de pokémon irán cambiando cada cierto tiempo; al igual que habrá eventos especiales para poder conseguir pokémon ¡Shiny!.</p>
            <p className={styles.p}>Una vez registrado en el PokeTimer, revisa tu correo electrónico con el que te registraste, ahí podras ver que tu información sea correcta(si no encuentras el correo revisa tu sección de spam).</p>
            <p className={styles.p}>Muchas gracias por utilizar el PokeTimer. Cualquier duda, queja o sugerencia puedes mandar un correo dando click aquí: <a href="mailto:poketimeroficial@gmail.com" >  Ir a correo electrónico.</a></p>
          </div>
        </div>
      </div>

    </div >
  );
}


export default Home;